import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BusinessUnitModel } from "../models/business-unit";
import { BehaviorSubject, Observable } from "rxjs";
import { AppServiceHelperService } from "../../../services/app-service-helper.service";

/**
 * Injectable
 */
@Injectable({
  providedIn: 'root'
})
export class BusinessUnitService {
  /**
   * Resource for the busines unit.
   */
  private _buResource: string;

  /**
   * Private BehaviorSubject representing add new BU navigation action
   */
  private _addNewBU$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  /**
   * Add new BU subject
   */
  public addNewBU$: Observable<boolean>;

  /**
 * Constructor
 * @param ais
 * @param httpClient
 */
  constructor(private appServiceHelper: AppServiceHelperService, private httpClient: HttpClient) {
    this._buResource = this.appServiceHelper.getServiceEndpoint('pollux.settings.api', 'user');
    this.addNewBU$ = this._addNewBU$.asObservable();
  }

  //#region API

  /**
 * Retrieves a list of bussiness units
 */
  getBUs(): Observable<BusinessUnitModel[]> {
    return this.httpClient.get<BusinessUnitModel[]>(`${this._buResource}/businessUnits`);
  }

  /**
* Updates bu
*/
  updateBU(bu: BusinessUnitModel): Observable<any> {
    return this.httpClient.post(`${this._buResource}/businessUnits`, bu);
  }

  /**
* Triggers add new bu action
*/
  setAddNewBUAction() {
    this._addNewBU$.next(true);
  }

}
